export default __webpack_public_path__ + "static/media/8507.6722d863.svg";